// extracted by mini-css-extract-plugin
export default {"page":"App_page__Iq0mc","flareAnimation":"App_flareAnimation__rx7pD","shine":"App_shine__ZtNg-"};